/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { WindowFormBase as WindowForm } from './WindowForm.base.js'
